import React from 'react';
import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Refresh } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  overflow: "hidden"
}));

const FormItem = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const RadioContainer = styled(FormControl)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const ChipsContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& > *': {
    margin: theme.spacing(0.5),
  },
}));

const EntityInfoLabel = styled(Typography)({
  wordBreak: 'break-word'
});


  export default function EntityInfo(props) {
    const selectedEntity =  props.selectedEntity ? { 
      ...props.selectedEntity,
      ...props.selectedEntityAdditionalProperties
    } : props.selectedEntity;
    const onFieldChange = (name, value) => {
      props.entityInfo[name] = value;
      props.onEntityInfoChanged(props.entityInfo);
    }

    return (
      <Root>
      <Grid container spacing={0} justifyContent="space-between">
        <Grid size={{ xs: 11 }}>
          <Typography variant="h6">
              Entity Information
          </Typography>
        </Grid>
        <Grid size={{ xs: 1 }}>
          {selectedEntity && selectedEntity.refresh 
          ? <Tooltip title="Reload">
              <IconButton onClick={() => { selectedEntity.refresh() }} size="small">
                <Refresh fontSize="small" />
              </IconButton>
            </Tooltip>
          : <></>  
        }
        </Grid>
      </Grid>

      <form noValidate autoComplete="off">
        
        {selectedEntity ? 
          <EntityInfoLabel variant="body1"><strong>Namespace:</strong> {selectedEntity.namespaceUrl}</EntityInfoLabel> 
          : 
          <FormItem>
            <TextField 
              size="small"
              onChange={(e) => { onFieldChange("namespaceUrl", e.target.value) }} 
              variant="outlined"
              value={props.entityInfo.namespaceUrl} 
              fullWidth 
              disabled={selectedEntity}
              label="Namespace URL" 
            />
          </FormItem>
        }

        
        {selectedEntity ? 
          <EntityInfoLabel variant="body1">
            <strong>Name:</strong> {selectedEntity.type === "subscription" ? `${selectedEntity.topic.name}/${selectedEntity.name}` : selectedEntity.name}
          </EntityInfoLabel>
          :
          <FormItem>
            <TextField 
              size="small"
              onChange={(e) => { onFieldChange("entityName", e.target.value) }} 
              variant="outlined"
              value={props.entityInfo.entityName} 
              fullWidth 
              disabled={selectedEntity}
              label="Entity Name" 
            />
          </FormItem>
        }
        
        
        {selectedEntity ? 
          <EntityInfoLabel variant="body1"><strong>Type:</strong> {selectedEntity.type}</EntityInfoLabel>
          :
          <RadioContainer component="fieldset">
            <FormLabel component="legend">Entity Type</FormLabel>
            <RadioGroup row aria-label="entityType" name="entityType">
                <FormControlLabel 
                  value="queue" 
                  onChange={(e) => { onFieldChange("entityType", e.target.value) }} 
                  checked={props.entityInfo.entityType === 'queue'} 
                  control={<Radio />} 
                  label="Queue" 
                />
                <FormControlLabel 
                  value="topic" 
                  onChange={(e) => { onFieldChange("entityType", e.target.value) }} 
                  checked={props.entityInfo.entityType === 'topic'} 
                  control={<Radio />} 
                  label="Topic" 
                />
                <FormControlLabel 
                  value="subscription" 
                  onChange={(e) => { onFieldChange("entityType", e.target.value) }} 
                  checked={props.entityInfo.entityType === 'subscription'} 
                  control={<Radio />} 
                  label="Subscription" 
                />
            </RadioGroup>
          </RadioContainer>
        }
        
        {selectedEntity && selectedEntity.forwardTo &&
            <EntityInfoLabel variant="body1"><strong>Forward to:</strong> {selectedEntity.forwardTo}</EntityInfoLabel>
        }

        {selectedEntity && selectedEntity.forwardDeadLetteredMessagesTo &&
            <EntityInfoLabel variant="body1"><strong>Forward DLQ to:</strong> {selectedEntity.forwardDeadLetteredMessagesTo}</EntityInfoLabel>
        }

        {selectedEntity && selectedEntity.rules &&
            selectedEntity.rules.map((rule, index) => 
              rule.sqlFilter && rule.sqlFilter.sqlExpression ? 
                <EntityInfoLabel key={index} variant="body1">
                  <strong>SQL Filter:</strong> {rule.sqlFilter.sqlExpression}
                </EntityInfoLabel> 
              : null
            )
        }  
        

        {selectedEntity && 
          <ChipsContainer>
            <Chip
              label={`Active: ${selectedEntity.countDetails.activeMessageCount} messages`}
              color="primary"
            />
            <Chip
              label={`Dead-Lettered: ${selectedEntity.countDetails.deadLetterMessageCount} messages`}
              color="primary"
            />
            <Chip
              label={`Scheduled: ${selectedEntity.countDetails.scheduledMessageCount} messages`}
              color="primary"
            />
          </ChipsContainer>
        }
      </form>
    </Root>
    );
  }